import Vue from "vue";
import App from "./App.vue";

// import Vant from "vant";
import { Popup } from "vant";
// import { Image as VanImage } from "vant";
import "vant/lib/index.css";

import * as L from "leaflet";
import "leaflet/dist/leaflet.css";

Vue.config.productionTip = false;

Vue.L = Vue.prototype.$L = L;

// Vue.use(Vant);
Vue.use(Popup);
// Vue.use(VanImage);

new Vue({
  render: (h) => h(App),
}).$mount("#app");
